import { FLEX_FINALIZE_PARENT_PATH, makePath } from 'shared';
function getPathWithToken(routePath, token) {
    const basePath = makePath(FLEX_FINALIZE_PARENT_PATH, routePath);
    if (token) {
        return `${basePath}?token=${encodeURIComponent(token)}`;
    }
    return basePath;
}
export default getPathWithToken;
